import * as yup from 'yup';

export const userChallengeValidationSchema = yup.object().shape({
  title: yup
    .string()
    .required({ id: 'validation.titleRequired', defaultMessage: 'Title is required' } as unknown as string)
    .min(3, {
      id: 'validation.titleMinLength',
      defaultMessage: 'Title must be at least 3 characters'
    } as unknown as string)
    .max(250, {
      id: 'validation.titleMaxLength',
      defaultMessage: 'Title must be at most 250 characters'
    } as unknown as string),
  subtitle: yup
    .string()
    .nullable()
    .max(250, {
      id: 'validation.subtitleMaxLength',
      defaultMessage: 'Subtitle must be at most 250 characters'
    } as unknown as string),
  access: yup.object({
    options: yup.object({
      ideaEditLock: yup.object({
        enabled: yup.boolean(),
        graceMinutes: yup
          .number()
          .nullable()
          .typeError({ id: 'validation.numberRequired', defaultMessage: 'A number is required' } as unknown as string)
          .when('enabled', (enabled: boolean | undefined, schema: yup.NumberSchema<number | null | undefined>) =>
            enabled
              ? schema.required({
                  id: 'validation.fieldRequired',
                  defaultMessage: 'This field is required'
                } as unknown as string)
              : schema.notRequired()
          )
      })
    })
  })
});
